<ng-container *ngIf="sidebarMenu.length>0;else noData">
  <div class="deznav">
    <div class="deznav-scroll mm-active">
      <ul class="metismenu mm-show" id="menu">

        <ng-container *ngFor="let menu of sidebarMenu; let i = index">
          <li class="menu-title" *ngIf="menu.urlType=='GROUP'">{{ menu.title }}</li>
          <ng-container>
            <ng-container
              *ngTemplateOutlet="
            sidebarTemp;
            context: { items: (menu.items && menu.items.length>0)?menu.items:[menu],level:i }
          "
            ></ng-container>
          </ng-container>
        </ng-container>
      </ul>

    </div>
  </div>

  <ng-template #sidebarTemp let-items="items" let-level="level">
    <ul class="level-{{level}}">
      <li *ngFor="let item of items" routerLinkActive="mm-active"
          [ngClass]="(item.expanded ? 'mm-active' : '')"
          [routerLinkActive]="['mm-active']">
        <ng-container *ngIf="item.urlType!='GROUP'">
          <a
            *ngIf="(!item.items || item.items.length==0)"
            aria-expanded="false"
            [routerLink]="item.url"
            [routerLinkActive]="['mm-active']"
            [ngClass]="(item.icon ? 'mm-icon' : '')"
          >
            <div class="menu-icon" *ngIf="item.icon" [innerHTML]="item.icon"></div>
            <span class="nav-text"> {{ item.title }} </span>
          </a>
          <a *ngIf="item.items && item.items.length>0"
             (click)="handleItemClick(item);"
             (keydown.enter)="handleItemClick(item)"
             [ngClass]="(item.expanded ? 'mm-active' : '')">
            <div class="has-arrow">
              <div class="menu-icon" *ngIf="item.icon" [innerHTML]="item.icon"></div>
              <span class="nav-text"> {{ item.title }} </span>
            </div>
          </a>

          <ul *ngIf="item.items && item.items.length>0"
              blurOthers
              [ngClass]="(item.expanded ? 'mm-show' : '')"
              [id]="item.expanded"
              class="left mm-collapse">
            <ng-container
              *ngTemplateOutlet="sidebarTemp; context: { items: item.items }"
            ></ng-container>
          </ul>
        </ng-container>
      </li>
    </ul>

  </ng-template>
</ng-container>
<ng-template #noData>
  <div class="deznav">
    <div class="deznav-scroll mm-active" *ngIf="!loading">
      <div class="card-header border-0 pb-0  d-grid text-center">
        <h5 class="card-title text-muted d-grid text-center">
          <i class="mdi mdi-cards-outline display-5"></i>
          {{ 'general.sidebar.no-menu-data' | translate }}
        </h5>
        <small class="text-muted mt-3">{{ 'general.sidebar.no-menu-data-description' | translate }}</small>
      </div>

      <div class="card-body p-0">
        <div id="DZ_W_TimeLine" class="widget-timeline dz-scroll my-4 px-4">
          <ul class="timeline">
            <li>
              <div class="timeline-badge primary"></div>
              <a class="timeline-panel " routerLink="/management/menu/management">
                <span>Menu Grubu</span>
                <h6 class="mb-0"><strong
                  class="text-primary">Sidebar</strong> adında ve <strong
                  class="text-primary">sidebar</strong> tagında menü grubu oluştur.
                </h6>
              </a>
            </li>
            <li>
              <div class="timeline-badge info">
              </div>
              <a class="timeline-panel " routerLink="/management/menu/management">
                <span>Sidebar Menü Başlıkları</span>
                <h6 class="mb-0">Menüleri belli başlıklar altında toplamak için <strong class="text-info">Url
                  Tipi</strong> <strong
                  class="text-primary"> GROUP </strong> olan menü oluştur.</h6>
                <p class="mb-0 mt-3">Bu menü Sidebar'da menüleri belli başlıklarda toplamak için kullanılır.</p>
              </a>
            </li>
            <li>
              <div class="timeline-badge danger">
              </div>
              <a class="timeline-panel " routerLink="/management/menu/management">
                <span>İç içe Menüler</span>
                <h6 class="mb-0">Alt menülerin bağlı olduğu bir üst menü oluşturmak için <strong class="text-info">Url
                  Tipi</strong> <strong
                  class="text-primary"> FUNCTION </strong> olan menü oluştur ve <strong class="text-info">Url</strong>
                  bilgisini <strong class="text-warning">#</strong> olarak kaydet.</h6>
              </a>
            </li>
            <li>
              <div class="timeline-badge success">
              </div>
              <a class="timeline-panel" routerLink="/management/menu/management">
                <span>Gerçek Menü</span>
                <h6 class="mb-0"><strong class="text-info">Url
                  Tipi</strong> <strong
                  class="text-primary"> ROUTE ve STATIC </strong> olarak oluşturulacak olan menüler tek başına yada alt
                  menü elemanı olarak kaydedilebilir.</h6>

                <p class="mb-0 mt-3">Menüler sürükle bırak ile konumlandırılabilir.</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>
